export interface ApplicationReference {
  applicationReference: string;
}

export interface Application {
  applicationReference: string;
  departmentReference?: string;
  name?: string;
  created?: string;
  updated?: string;
  status: number;
  partyId?: number;
  customerId?: number;
  inviteDetail?: InviteDetail;
  isJoint?: boolean;
  progress?: number;
  isExpired?: boolean;
  idvCheckCompleted?: boolean;
  shareWorkReportData?: boolean;
  shareOpenBankingData?: boolean;
  shareIdDocData?: boolean;
  accountRequirementCheckStatus?: string;
  applicantReference?: string;
  journeyStatus?: StepData;
  recategorisationStatus?: string;
  caisCurrentAccountCount?: number;
}

export type StepData = {
  openBanking?: 'Skipped' | 'Completed' | 'ConsentDeclined' | string;
  workReport?: 'Skipped' | 'Completed' | 'ConsentDeclined' | string;
  idDoc?: 'Skipped' | 'Completed' | 'ConsentDeclined' | string;
};

export enum StepDataStatus {
  Skipped = 'Skipped',
  Completed = 'Completed',
  ConsentDeclined = 'ConsentDeclined',
}

export interface JointApplication {
  created: string;
  applicationReference: string;
  departmentReference: string;
  status: number;
  partyName: string;
}

export interface InviteDetail {
  inviteSent: string;
  expirationDate: string;
  reminderCount: number;
}

export interface ApplicationResponse {
  totalApplications: number;
  records: ApplicationRecord[];
}

export interface ApplicationRecord {
  status: string;
  isJoint: boolean;
  applications: Application[];
}

export interface CreateApplication {
  departmentReference: string;
  journeyId: number;
  customerId: number;
  dataOption?: DataOptions;
}

export enum DataOptions {
  BE = 1,
  BEI = 2,
  M1 = 3,
  'M3+' = 4,
  'BE+' = 5,
}

export interface ApplicationEvent {
  id: string;
  name: string;
  description: string;
  timestamp: string;
}

export class ApplicationEventResponse {
  applicationReference: string;
  departmentReference: string;
  events: ApplicationEvent[];
}

export class ApplicationSummary {
  score: number;
  status: string;
  filter: string;
  progress: ProgressValue;
}

export class ProgressValue {
  value: number;
  backgroundColor?: string;
}

export class JointApplicationPayload {
  departmentReference: string;
  items: CustomerItems[];
  journeyId: number;
}

export interface CustomerItems {
  customerId: number;
  applicantReference: string;
}

export interface ApplicationStatuses {
  totalApplications: number;
  statuses: Statuses[];
}

export interface Statuses {
  status: string;
  count: number;
}

export interface PartnerOpenBankingCapabilities {
  transactionHistoryMonths: number;
  transactionsCompletedMonthsOnly: boolean;
}

export interface TabConfig {
  journeyStage: string;
  title: string;
  dataMessage: string;
  route: string;
  qaId: string;
  isEnabledForDepartment: boolean;
  dropdown?: {
    title: string;
    value: string;
    path: string;
  }[];
  isDataComplete: boolean;
  tooltipText: string;
  isTabVisible: boolean;
}

export interface ApplicationStatus {
  id: string;
  title: string;
  description: string;
  status: string;
  journeyIdentifier: string;
  route: string;
  showButton: boolean;
}

export interface StepperData {
  id: string;
  title: string;
  status: string;
}
